import { Component,  NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Unsubscribable } from 'rxjs';
import { DnDialogService } from '../_modules/dn-dialog/dn-dialog.service';
import { ConfigService } from '../_service/config/config.service';
import { UserService } from '../_service/user/user.service';

@Component({
  selector: 'app-challenge',
  templateUrl: './challenge.component.html',
  styleUrls: ['./challenge.component.scss']
})
export class ChallengeComponent implements OnInit {
  subscritions: Array<Unsubscribable> = [];
  returnUrl;
  publickKey = "";

  constructor(private _userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private zone: NgZone,
    private config:ConfigService,
    private dialog:DnDialogService
  ) { }
  ngOnDestroy(): void {
    this.subscritions.forEach(p => p.unsubscribe());
  }



  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.returnUrl = params['return'];
      this.subscritions.push(this.config.config$.subscribe(p => {
        if (!!p.apiVersion) {
          this.publickKey = p.authConfig.publicKey;
          this.addRecaptchaScript();
        }
        
      }))

    });



    window["onValidateCallback"] = (res) => {
      this.zone.run(() => {
        this._userService.clearOverWatch({
          captchaKey: res,
          publicKey: this.publickKey
        }).subscribe(p => {
          if (p.length > 0) {
            this.router.navigateByUrl(this.returnUrl || "");
          }
          else
          {
            // this.messageService.setState({ message: '验证失败，请重试' });
            this.dialog.open('message-dialog',{ message: '验证失败，请重试' });
          }
        })
      })
    };

    // if(!environment.production)
    // {
    //   window["onValidateCallback"]("1");
    // }

  }

  addRecaptchaScript() {
    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      //if (d.getElementById(id)) { obj.renderReCaptch(); return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));

  }



}
